<div class="simple-table position-relative">
  <span *ngIf="props.label" class="bold">{{ props.label }}:</span>

  <div class="simple-table w-100">
    <div
      *ngFor="let row of props.tableRows; let index = index"
      class="simple-table__row"
      [class.simple-table__row--double]="row.fields.length === 2"
      [class.simple-table__row--full-width-label]="props.fullWidthLabel"
    >
      <div class="simple-table__key bold">
        {{ row.label }}
      </div>
      <div
        class="simple-table__value"
        [class.table__value--tooltip]="!!row.tooltip"
      >
        <formly-form
          class="w-100"
          [form]="$any(internalForm.at(index))"
          [fields]="row.fields"
          (modelChange)="onModelChange()"
        ></formly-form>
      </div>
      <div class="simple-table__tooltip">
        <lui-avatar
          *ngIf="row.tooltip"
          color="primary"
          size="20px"
          [matTooltip]="row.tooltip"
          [useClickListener]="true"
        >
          <mat-icon svgIcon="i"></mat-icon>
        </lui-avatar>
      </div>
    </div>
  </div>
</div>
